<div><h3 mat-dialog-title>Active Version Notice</h3>
    <div style="padding-left: 24px; padding-right: 24px;">
        You are currently in the active version. Please confirm changes should be made in this version.
    </div>
</div>
<br>

<div class="fx-row-center" style="padding-bottom: 24px;">
<button color="primary" mat-raised-button id="Confirm" class="mat-raised-button" type="button" label="Confirm" (click)="onConfirm()">
    Confirm
</button>
<button color="primary" mat-raised-button id="Close" class="mat-raised-button" type="button" label="Close" (click)="onNoClick()">
    Close
</button>
</div>

